import {$} from '../jquery-definition.js';
import 'jquery.equalheights';

$( function() {
	$( '.equal-heights' ).equalHeights( {
		wait: true,
		watch: true
	} );
} );
